module.exports = __webpack_public_path__ + "img/after4.adb4146b.jpg";